import { Component } from 'react';

class StellaError extends Component {
  render() {
    if (!this.props.error) {
      return null;
    }
    let styles = {
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      float: 'left',
      textAlign: 'center',
      backgroundColor: 'rgba(250,250,250,0.7)',
      position: 'absolute',
      zIndex: 100,
    };

    let imageStyle = {
      marginTop: '300px',
    };

    let textStyle = {
      color: '#d51c26', // alchemy expressiveNegative.base
      fontWeight: 600,
    };
    return (
      <div style={styles}>
        <img style={imageStyle} src={this.props.errorImage} />
        <p style={textStyle}>
          Something went wrong. Please try refreshing the page.
        </p>
      </div>
    );
  }
}

export default StellaError;
